import { AccountRoutes } from "@/routes/AccountRoutes";
import { Accounts } from "@/routes/Accounts";
// 导航里每个菜单项对应的页面组件，按路径查（与 app/nav.ts 的 NAV 一一对应，测试检查）。单独一个文件：App.tsx 只导出组件，热更新才生效。
import { RoutingRules } from "@/routes/RoutingRules";
import { RoutingTemplates } from "@/routes/RoutingTemplates";
import { AdminUsers } from "@/routes/AdminUsers";
import { Audit } from "@/routes/Audit";
import { Captures } from "@/routes/Captures";
import { Balances } from "@/routes/Balances";
import { ChannelGroups } from "@/routes/ChannelGroups";
import { ChannelHealth } from "@/routes/ChannelHealth";
import { Channels } from "@/routes/Channels";
import { DLRPolicies } from "@/routes/DLRPolicies";
import { Customers } from "@/routes/Customers";
import { Messages } from "@/routes/Messages";
import { Notify } from "@/routes/Notify";
import { Numbering } from "@/routes/Numbering";
import { Overview } from "@/routes/Overview";
import { CurrencyRates } from "@/routes/CurrencyRates";
import { PriceSyncTasks } from "@/routes/PriceSyncTasks";
import { Prices } from "@/routes/Prices";
import { AlertThresholds } from "@/routes/AlertThresholds";
import { ProfitGuards } from "@/routes/ProfitGuards";
import { SenderPolicies } from "@/routes/SenderPolicies";
import { Suppliers } from "@/routes/Suppliers";
import { TestSend } from "@/routes/TestSend";
import { Traffic } from "@/routes/Traffic";
import { UiOverview } from "@/routes/UiOverview";
import { CustomerReport, SupplierReport } from "@/routes/BillingReport";

/** 菜单路径到页面组件。 */
export const PAGES: Record<string, () => JSX.Element> = {
  "/account-routing": AccountRoutes, "/overview": Overview, "/traffic": Traffic, "/messages": Messages, "/channels": Channels, "/channel-health": ChannelHealth, "/captures": Captures, "/test-send": TestSend, "/routing-rules": RoutingRules, "/routing-templates": RoutingTemplates, "/channel-groups": ChannelGroups,
  "/dlr-policies": DLRPolicies, "/customers": Customers, "/accounts": Accounts, "/suppliers": Suppliers, "/prices": Prices, "/price-sync-tasks": PriceSyncTasks, "/currency-rates": CurrencyRates, "/numbering": Numbering,
  "/balances": Balances, "/customer-report": CustomerReport, "/supplier-report": SupplierReport, "/profit-guards": ProfitGuards, "/alert-thresholds": AlertThresholds, "/sender-policies": SenderPolicies, "/audit": Audit, "/admin-users": AdminUsers, "/notify": Notify, "/ui": UiOverview,
};
